module.exports = __webpack_public_path__ + "img/ico_function1.d3b688d9.svg";